<template>
  <div v-if="!consentGiven" class="cookies-consent-popup">
    This site uses cookies for a better browsing experience. By continuing, you
    agree to our cookie use.
    <button class="btn btn-outline-info" @click="giveConsent">Accept</button>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'

export default {
  name: 'CookiesConsentPopup',
  data() {
    return {
      consentGiven: VueCookies.get('cookies-consent'),
    }
  },
  methods: {
    giveConsent() {
      this.consentGiven = true
      VueCookies.set('cookies-consent', true, '7d') // Set for 7 days
    },
  },
}
</script>

<style scoped>
.cookies-consent-popup {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--bs-gray-500);
  padding: 7px;
  text-align: center;
  z-index: 1000;
}
</style>
